import Link from "next/link";
import { useRouter } from "next/router";
import Image from "next/image";
import { useMediaQuery } from "react-responsive";
import FadeIn from "react-fade-in";

import styles from "./style.module.css";
import { useAuth } from "../../src/auth";
import { AuthType } from "types/enums";
import { userIsEnterprise, userIsCandidate, userIsAdmin } from "@src/helpers";
import Close from "@assets/close-button.png";
import HamburgerMenuIcon from "@components/HamburgerMenuIcon";
import { useAppState } from "@src/state";
// import NavbarMenu from './NavbarMenu'
import SearchNav from "./SearchNav";
import NotificationsMenu from "./NotificationsMenu";
import NotificationMenuIcon from "@components/NotificationIcon";

import Logo from "@assets/logo_10.png";
import MainLogoSVG from "@assets/logo_new_3.svg";
import MainLogoEnterpriseSVG from "@assets/main_logo_enterprise_two.svg";
import BigLogo from "@assets/big_logo_2.svg";
import { useEffect, useState, useRef } from "react";
import MobileSearchNav from "./MobileSearchNav";
import SearchTooltip from "@components/Tooltips/SearchTooltip";
import { Button } from "semantic-ui-react";

interface NavBarProps {
  userType?: AuthType;
  isSearchNav?: Boolean;
  showDashLink?: Boolean;
  authNav?: Boolean;
  authType?: String;
  home?: Boolean;
  onboarding?: Boolean;
  isAdmin?: Boolean;
}

const candidateSignupUrl = "/signup";
const employerSignupUrl = "/employer/signup";

export default function NavBar({
  home,
  userType,
  authNav,
  authType,
  isSearchNav,
  onboarding,
  isAdmin,
}: NavBarProps) {
  const { signOutUser, user, adminUser, revert } = useAuth();
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 820px)" });
  const router = useRouter();
  const { state: appState, dispatch: appDispatch } = useAppState();
  const atHome = router.pathname === "/" || router.pathname === "/jobs";
  const { mobileMenu } = appState;
  const [firstRender, setFirstRender] = useState(true);
  const [closing, setClosing] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const prevMenu = usePrevious(mobileMenu);

  useEffect(() => {
    setTimeout(() => setFirstRender(false), 200);
  }, []);

  useEffect(() => {
    if (prevMenu && !mobileMenu) {
      setTimeout(() => setClosing(false), 50);
    }
  }, [mobileMenu]);

  const openMobileMenu = () => {
    appDispatch({ type: "open_mobile_menu" });
  };

  const closeMobileMenu = () => {
    setClosing(true);
    appDispatch({ type: "close_mobile_menu" });
  };

  const renderRightStuffSearch = () => {
    if (authNav) {
      if (authType === "employerSignup") {
        return (
          <Link href={candidateSignupUrl} passHref>
            <a>
              <div className={styles.dashboard}>Jobseeker Signup</div>
            </a>
          </Link>
        );
      }
      if (authType === "candidateSignup") {
        // return null;

        return (
          <Link href="/signin">
            <a>
              <div className={styles.dashboard}>Sign In</div>
            </a>
          </Link>
        );

        return (
          <Link href={employerSignupUrl} passHref>
            <a>
              <div className={styles.dashboard}>Employer Signup</div>
            </a>
          </Link>
        );
      }

      return null;
    }

    if (user) {
      return (
        <div className={styles.rightStuffContainer}>
          {!onboarding && (
            <NotificationsMenu
              userType={userType}
              expanded={expanded}
              setExpanded={setExpanded}
              icon={
                <NotificationMenuIcon
                  className={styles.notificationIcon}
                  hover={expanded}
                />
              }
            />
          )}
        </div>
      );
    } else {
      return (
        <div className={styles.useractions}>
          <Link href="/signin" passHref>
            <a>
              <div className={styles.signIn}>Sign In</div>
            </a>
          </Link>
          <Link href="/signup" passHref>
            <a>
              <div className={styles.signIn}>
                <button className={styles.signupButton}>
                  Create An Account
                </button>
              </div>
            </a>
          </Link>
        </div>
      );
    }
  };

  const renderRightStuff = () => {
    if (authNav) {
      if (authType === "employerSignup") {
        return (
          <Link href={candidateSignupUrl} passHref>
            <a>
              <div className={styles.dashboard}>Jobseeker Signup</div>
            </a>
          </Link>
        );
      }
      if (authType === "candidateSignup") {
        return (
          <Link href="/signin">
            <a>
              <div className={styles.dashboard}>Sign In</div>
            </a>
          </Link>
        );
      }

      return null;
    }

    if (user) {
      const isEnterprise = userIsEnterprise(user);
      const isCandidate = userIsCandidate(user);
      const isAdmin = userIsAdmin(user);

      const renderAutoApply = () => {
        if (
          isEnterprise ||
          onboarding ||
          router.pathname === "/candidate/dashboard/auto"
        ) {
          return null;
        }

        if (isCandidate) {
          return (
            <Link href="/candidate/dashboard/auto/" passHref>
              <a>
                <div className={styles.goToSearch}>Auto-Apply</div>
              </a>
            </Link>
          );
        }

        return (
          <Link href="/ai-auto-apply/" passHref>
            <a>
              <div className={styles.goToSearch}>Auto-Apply</div>
            </a>
          </Link>
        );
      };
      return (
        <div className={styles.rightStuffContainer}>
          {isAdmin && (
            <Link href="/admin" passHref>
              <a>
                <div className={styles.goToSearch}>Admin</div>
              </a>
            </Link>
          )}
          {isAdmin && user !== adminUser && (
            <div
              style={{
                position: "fixed",
                top: "0",
                left: "50%",
                transform: "translateX(-50%)",
                padding: "10px",
                backgroundColor: "red",
                color: "white",
              }}
            >
              {`You are impersonating ${user?.username}`}{" "}
              <Button size="tiny" secondary onClick={() => revert()}>
                Stop Impersonating
              </Button>
            </div>
          )}
          {renderAutoApply()}
          {!onboarding && (
            <NotificationsMenu
              userType={userType}
              expanded={expanded}
              setExpanded={setExpanded}
              icon={
                <NotificationMenuIcon
                  className={styles.notificationIcon}
                  hover={expanded}
                />
              }
            />
          )}
        </div>
      );
    } else {
      return (
        <div className={styles.useractions}>
          <Link href="/about" passHref>
            <a>
              <div className={styles.signIn}>About</div>
            </a>
          </Link>
          <Link href="/ai-auto-apply/" passHref>
            <a className={styles.blogLink}>
              <div className={styles.signIn}>Auto-Apply</div>
            </a>
          </Link>
          <Link href="/#pricing" passHref>
            <a>
              <div className={styles.signIn}>Pricing</div>
            </a>
          </Link>
          <Link href="/signin" passHref>
            <a>
              <div className={styles.signIn}>Sign In</div>
            </a>
          </Link>
          <Link href="/signup" passHref>
            <a>
              <div className={styles.signIn}>
                <button className={styles.signupButton}>
                  Create An Account
                </button>
              </div>
            </a>
          </Link>
        </div>
      );
    }
  };

  if (firstRender && home) {
    return <div className={styles.navContainer}></div>;
  }

  if (isTabletOrMobile) {
    if (isSearchNav) {
      return (
        <MobileSearchNav
          openMobileMenu={openMobileMenu}
          closeMobileMenu={closeMobileMenu}
          closing={closing}
          mobileMenu={mobileMenu}
        />
      );
    }

    return (
      <div
        className={`${mobileMenu ? styles.navOpenWrapper : ""} ${
          styles.mobileHeader
        }`}
      >
        <div
          className={mobileMenu ? styles.mobileNavOpen : styles.mobileNavClosed}
        >
          {!appState?.mobileMenu && !closing && (
            <div className={styles.fade}>
              <MainLogo mobile />
            </div>
          )}
          {appState.mobileMenu && (
            <div className={styles.mobileMenuLogo}>
              <FadeIn>
                <Image src={Logo} alt="logo" width={40} height={40} />
              </FadeIn>
            </div>
          )}
          {!appState?.mobileMenu && (
            <div className={styles.menuIcon} onClick={openMobileMenu}>
              <HamburgerMenuIcon mobile />
            </div>
          )}

          {appState.mobileMenu && (
            <div
              className={`${styles.menuIcon} ${styles.closeIcon}`}
              onClick={closeMobileMenu}
            >
              <Image
                src={Close}
                className={styles.closeButton}
                width={20}
                height={20}
                alt="close  menu"
              />
            </div>
          )}
        </div>
      </div>
    );
  }

  if (isSearchNav) {
    return (
      <SearchNav
        RightContents={renderRightStuffSearch}
        Logo={() => <MainLogo userType={userType} />}
      />
    );
  }

  if (authType === "candidateLogin" || authType === "employerLogin") {
    return (
      <div className={`${styles.container} ${styles.loginContainer}`}>
        <div className={`${styles.contentWrapper} ${styles.login}`}>
          <MainLogo userType={userType} large type={authType} />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.contentWrapper}>
        <MainLogo userType={userType} />
        <div className={styles.rightContainer}>{renderRightStuff()}</div>
      </div>
    </div>
  );
}

export function MainLogo({
  userType,
  mobile,
  large,
  type,
  landing,
  landingTwo,
}) {
  let height = 40;
  let width = 40;
  let url = "/";

  if (large) {
    height = 55;
    width = 55;
  }

  if (type === "candidateLogin") {
    url = "/signin";
  } else if (type === "employerLogin") {
    url = "/employer/signin";
  }

  if (large) {
    return (
      <Link href="/" passHref>
        <a>
          <BigLogo />
        </a>
      </Link>
    );
  }

  let style = {};
  if (mobile) {
    style = { transform: "scale(.9)", position: "relative" };
  }

  if (userType === AuthType.Enterprise || type === "employerLogin") {
    return (
      <Link href="/" passHref>
        <MainLogoEnterpriseSVG />
      </Link>
    );
  }

  return (
    <Link href={"/"} passHref>
      <a className={styles.logoWrapper}>
        <div style={style} className={styles.innerLogoWrapper}>
          <MainLogoSVG />
        </div>
      </a>
    </Link>
  );
}

// Hook
function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  const ref = useRef();
  // Store current value in ref
  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes
  // Return previous value (happens before update in useEffect above)
  return ref.current;
}
